import * as TYPES from '../types';

export const addEventAction = (payload) => {
    return {
        type: TYPES.ADD_EVENT,
        payload: payload
    };
};

export const getAllEventAction = () => {
    return {
        type: TYPES.GET_ALL_EVENT,
    };
};

export const getAllEventSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_EVENT_SUCCESS,
        payload: payload
    };
};

export const deleteEventAction = (payload) => {
    return {
        type: TYPES.DELETE_EVENT,
        payload: payload
    };
};

export const editEventAction = (payload) => {
    return {
        type: TYPES.EDIT_EVENT,
        payload: payload
    };
};

export const deleteEventImageAction = (payload) => {
    return {
        type: TYPES.DELETE_EVENT_IMAGE,
        payload: payload
    };
};

export const updateEventStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_EVENT_STATUS,
        payload: payload
    };
};